import { TrashBinIcon } from '../../../assets/icons/icons';
import { Button } from '../../ui/Button/Button';
import { Modal, ModalActions } from '../../ui/Modal/Modal';
import type { Project } from '../../../types/projectsTable';
import React from 'react';

type DeleteTarget = Project | number | null;

interface DeleteProjectModalProps {
    open: boolean;
    target: DeleteTarget;
    onClose: () => void;
    onConfirm: () => void;
}

const describe = (target: DeleteTarget): string => {
    if (typeof target === 'number') {
        return `Будет удалено проектов: ${target}. Действие нельзя отменить.`;
    }
    if (target) {
        return `Проект «${target.name}» и все его позиции будут удалены безвозвратно.`;
    }
    return 'Действие нельзя отменить.';
};

export function DeleteProjectModal({ open, target, onClose, onConfirm }: DeleteProjectModalProps) {
    const title = typeof target === 'number' ? 'Удалить выбранные проекты?' : 'Удалить проект?';

    return (
        <Modal
            open={open}
            width={420}
            tone="danger"
            title={title}
            description={describe(target)}
            icon={<TrashBinIcon />}
            onClose={onClose}
            footer={
                <ModalActions>
                    <Button onClick={onClose}>Отмена</Button>
                    <Button variant="danger" onClick={onConfirm}>
                        Удалить
                    </Button>
                </ModalActions>
            }
        />
    );
}
